<template>
  <div class="row">
    <div class="col-12 mb-3 col-sm-6" v-for="p in projects" :key="'p' + p.id">
      <div class="card shadow-lg">
        <my-project :project="p" @reload="reload" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'MyProjects',
  computed: {
    ...mapState({
      auth: state => state.auth,
      resourceStore: state => state.projectsStore
    }),
    projects () {
      return this._.filter(this.resourceStore, r => r.users.includes(this.auth.id))
    }
  },
  mounted () {
    this.reload()
  },
  methods: {
    reload () {
      this.$store.dispatch('index', { collection: 'projects' })
    }
  }
}
</script>
